export default "/assets/markers/delivered_on_grayscale.png"